<template>
	<v-footer id="dashboard-core-footer">
		<v-container>
			<v-row align="center" no-gutters>
				<v-col class="text-center mb-sm-0 mb-5" cols="auto">
					<span>Boss24 ©2019 Created by Mirasoft</span>
				</v-col>
			</v-row>
		</v-container>
	</v-footer>
</template>

<script>
	export default {
		name: "DashboardCoreFooter",

		data: () => ({})
	};
</script>

<style lang="scss" scoped>

</style>
